import loadable from 'Components/AsyncModuleLoader/AsyncModuleLoader';

export default loadable({
    loader: () => import(
        /* webpackChunkName: "callToActions" */
        /* webpackPreload: true */
        './CallToActions.APP_TARGET'),
    loading: null
});
